import { forwardRef, memo } from 'react';

import { SearchCommandInput, type SearchCommandInputProps } from '~/components/SearchCommand/SearchCommandInput';
import {
  SmartSearchCommandInput,
  type SmartSearchCommandInputProps,
} from '~/components/SearchCommand/SmartSearchCommandInput';

export type SearchCommandInputBaseProps = (SearchCommandInputProps | SmartSearchCommandInputProps) & {
  canUseSmartSearch: boolean;
  compact?: boolean;
};

export const SearchCommandInputBase = memo(
  forwardRef<HTMLInputElement, SearchCommandInputBaseProps>(
    ({ compact, count, onValueChange, placeholder, value, canUseSmartSearch }: SearchCommandInputBaseProps, ref) => {
      const InputComponent = canUseSmartSearch ? SmartSearchCommandInput : SearchCommandInput;

      return (
        <InputComponent
          compact={compact}
          count={count}
          onValueChange={onValueChange}
          placeholder={placeholder}
          value={value}
          ref={ref}
        />
      );
    },
  ),
);

SearchCommandInputBase.displayName = 'SearchCommandInputBase';
